import { render, staticRenderFns } from "./AddSeries.vue?vue&type=template&id=1c0f33be&scoped=true&"
import script from "./AddSeries.vue?vue&type=script&lang=js&"
export * from "./AddSeries.vue?vue&type=script&lang=js&"
import style0 from "./AddSeries.vue?vue&type=style&index=0&id=1c0f33be&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0f33be",
  null
  
)

export default component.exports